import { ButtonProps, useTheme } from '@mui/material'
import { designTokens } from '@/theme'
import AppButton from '@/components/ui/AppButton'

/**
 * Prominent platform primary action.
 * Color comes from the canonical `primaryActionSx` via AppButton.
 * Layout/elevation only — no second fill or gradient contract.
 */
const PrimaryButton = (props: ButtonProps) => {
  const theme = useTheme()
  const { cta } = theme.customTokens

  return (
    <AppButton
      variantType="primary"
      {...props}
      type={props.type ?? 'button'}
      sx={[
        {
          fontWeight: 700,
          borderRadius: '28px',
          py: 1.6,
          textTransform: 'none',
          fontSize: (t) => t.typography.body1.fontSize,
          boxShadow: cta.shadow,
          transition: `all ${designTokens.motion.normal}`,
        },
        ...(props.sx == null ? [] : Array.isArray(props.sx) ? props.sx : [props.sx]),
      ]}
    />
  )
}

export default PrimaryButton
